/** @format */

import React, { Component } from 'react';
import { Modal, Form, Icon, Header } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { hours, minutes } from '../../../../../helpers/hours';

@inject('RequestsStore')
@observer
class RequestCommunicationModal extends Component {
  formSubmit = () => {
    const { RequestsStore } = this.props;
    RequestsStore.addCommunication();
  };

  render() {
    const { RequestsStore } = this.props;
    return (
      <Modal open={RequestsStore.requestsParams.communicationForm.open}>
        <Modal.Content>
          <Header className="modal-header" as="h3">
            <small>
              <Icon name="phone" />
            </small>
            Nuova comunicazione
          </Header>
          <div className="header-spacer"></div>
          <Form
            className="modal-form"
            size="small"
            onSubmit={() => this.formSubmit()}
          >
            <Form.Select
              error={
                RequestsStore.requestsParams.communicationForm.errors.includes(
                  'state',
                )
                  ? true
                  : false
              }
              options={[
                {
                  text: 'Cliente non risponde da richiamare',
                  value: 'toRecall',
                },
                {
                  text: 'Cliente avvisato da richiamare',
                  value: 'notified',
                },
              ]}
              name="state"
              label="Esito Comunicazione"
              onChange={(e, input) => {
                RequestsStore.handleCommunicationInput(e, input);
              }}
              placeholder="Esito comunicazione"
            />
            <Form.Group widths="equal">
              <Form.Input
                error={
                  RequestsStore.requestsParams.communicationForm.errors.includes(
                    'recallDate',
                  )
                    ? true
                    : false
                }
                type="date"
                name="recallDate"
                label="Data Richiamo"
                onChange={(e, input) => {
                  RequestsStore.handleCommunicationInput(e, input);
                }}
              />
              <Form.Select
                error={
                  RequestsStore.requestsParams.communicationForm.errors.includes(
                    'recallHour',
                  )
                    ? true
                    : false
                }
                search
                options={hours}
                name="recallHour"
                label="Ora"
                onChange={(e, input) => {
                  RequestsStore.handleCommunicationInput(e, input);
                }}
                placeholder="Ora"
              />
              <Form.Select
                search
                options={minutes}
                error={
                  RequestsStore.requestsParams.communicationForm.errors.includes(
                    'recallMinutes',
                  )
                    ? true
                    : false
                }
                name="recallMinutes"
                label="Minuti"
                onChange={(e, input) => {
                  RequestsStore.handleCommunicationInput(e, input);
                }}
                placeholder="Minuti"
              />
            </Form.Group>
            <Form.TextArea
              autoComplete="off"
              rows="3"
              name="note"
              label="Note Comunicazione"
              onChange={(e, input) => {
                RequestsStore.handleCommunicationInput(e, input);
              }}
            />
            <Form.Button type="submit" color="green" fluid>
              <Icon name="phone" /> Salva Comunicazione
            </Form.Button>
          </Form>
          <div
            className="close-button"
            onClick={() => {
              RequestsStore.toggleCommunicationModal();
              RequestsStore.resetCurrentCommunication();
            }}
          >
            X
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

export default RequestCommunicationModal;
